import { TimeReservationAction, CreatePaymentDto } from "./types";

export const DOMAIN = "https://bilety.teatr.torun.pl";
// export const DOMAIN = "http://77.252.144.133:7070";
//export const DOMAIN = "http://localhost:4001";
//export const DOMAIN = "http://10.0.0.201:4001";

export const urls = {
  v1: {
    spectacle: {
      fetchAudience(spectacleId: number) {
        return `${DOMAIN}/api/spectacle/${spectacleId}/audience`;
      },

      reserveSeat(seatId: number, spectacleId: number) {
        return `${DOMAIN}/api/spectacle/${spectacleId}/seat/${seatId}`;
      },

      fetchPrices() {
        return `${DOMAIN}/api/spectacle/prices`;
      },
    },

    payments: {
      createPayment() {
        return `${DOMAIN}/api/payments/`;
      },
    },
  },
};

export const reserveSeat = (
  id: number,
  spectacleId: number,
  action: TimeReservationAction,
  token: string | null,
) =>
  fetch(urls.v1.spectacle.reserveSeat(id, spectacleId), {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      action,
      token,
    }),
  });

export const fetchAudience = (id: number) =>
  fetch(urls.v1.spectacle.fetchAudience(id), {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
  });

export const fetchPrices = () =>
  fetch(urls.v1.spectacle.fetchPrices(), {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
  });

export const createPayment = (body: CreatePaymentDto) =>
  fetch(urls.v1.payments.createPayment(), {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
